/**
 * @voltxampere/ui — Screw terminal block (Sprint 45-6, schema-only)
 *
 * Schema-only passthrough — engine'de davranış yok. PCB-mount
 * screw terminal — kalın kablo bağlantısı (motor power, mains AC,
 * sensor lead) için.
 *
 * Reference: Phoenix Contact MKDS / Würth WR-TBL — PCB-mount
 * 2-12 pole. Pitch 3.5/5.0/7.5 mm. 10-30 A per pole, 250-1000 V.
 * Power supply terminal, motor driver çıkışı, mains kontrol panel,
 * sensor field wiring.
 *
 * Engine zero-diff invariant honored — canonical `wire-node`
 * engine type via schemaType (passthrough).
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { node } from "../node.js";
export const connectorScrewTerminal = {
    id: "screw-terminal",
    nameTr: "Vidalı Klemens (PCB-mount, schema-only)",
    nameEn: "Screw Terminal Block (PCB-mount, schema-only)",
    shortcut: "N",
    category: "connector",
    viewBox: node.viewBox,
    terminals: node.terminals,
    defaultLabel: "J",
    defaultValue: "SCREW",
    schemaType: "wire-node",
    defaultParams: {},
    renderSVG: () => node.renderSVG(),
};
//# sourceMappingURL=connector-screw-terminal.js.map